import gql from 'graphql-tag'

export default gql`
  fragment PostContributors on Post {
    contributors {
      id
      action
      fullName
      userType
      userFkey
    }
  }
`
